import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-page-header',
  templateUrl: './page-header.component.html',
  styleUrls: ['./page-header.component.scss']
})
export class PageHeaderComponent implements OnChanges {
  @Input() badgeOrder?: any
  @Input() isBack = false;
  @Input() backRoute!: string;
  @Input() icon: any;
  @Input() title: any;
  @Input() hasSearch = false;
  @Input() searchLabel: any;
  @Input() hasAction = false;
  @Input() actionLabel: any;
  @Input() actionIsDisabled = false;
  @Input() styleActionButton = 'flat';

  // * EXPORT
  @Input() hasExportAction: boolean = false;
  @Input() exportLabel: any;
  @Output() exportHandler = new EventEmitter();

  // * SELECT
  @Input() hasSelect = false;
  @Input() selectOptions: any;
  @Input() optionValueProp!: string;
  @Input() optionLabelProp!: string;
  @Input() optionSelected: any;
  // *

  @Input() tableCols: any;

  @Input() hasRefresh = false;
  // * COLUMN VISIBILITY
  @Input() hasColumnVisibility = false;
  // *

  @Output() handle_onSearch = new EventEmitter();
  @Output() handle_onAction = new EventEmitter();
  @Output() handle_onRefresh = new EventEmitter();

  constructor(private router: Router) { }

  triggerAction(event: any) {
    if (this.actionIsDisabled) {
      return;
    }
    this.handle_onAction.emit(event);
  }
  ngOnChanges(changes: SimpleChanges) {
    if (changes?.['badgeOrder']?.currentValue) this.badgeOrder = changes['badgeOrder'].currentValue;
    if (changes?.['actionLabel']?.currentValue) this.actionLabel = changes['actionLabel'].currentValue;

  }
  goBack() {
    this.router.navigateByUrl(this.backRoute);
  }

  doExportAction() {
    this.exportHandler.emit();
  }

  doRefreshAction() {
    this.handle_onRefresh.emit();
  }


}
